import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function SalesHero() {
  return <section className="relative flex items-center justify-center bg-[#1e2d4d] text-white overflow-hidden pt-12 pb-16 px-4 md:px-6 md:pt-16 md:pb-20" data-id="element-64">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-65">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[#c9a84c] blur-[120px]" data-id="element-66" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-[#3a5280] blur-[120px]" data-id="element-67" />
      </div>

      <div className="max-w-6xl mx-auto w-full relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-68">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex-1 text-center md:text-left" data-id="element-69">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-70">
            Adiós al trabajo físico: <br data-id="element-71" />
            <span className="text-[#c9a84c]" data-id="element-72">
              Tu ruta de escape al mundo digital
            </span>{' '}
            <br data-id="element-73" />
            <span className="text-2xl md:text-3xl font-bold text-[#c9a84c] opacity-90 block mt-2" data-id="element-74">
              (Sin hablar inglés)
            </span>
          </h1>

          <h2 className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed max-w-2xl mx-auto md:mx-0" data-id="element-75">
            Cómo generar tus primeros{' '}
            <span className="text-white font-bold" data-id="element-76">
              $50 a $150 dólares diarios
            </span>{' '}
            trabajando desde casa para negocios latinos en EE.UU., aunque hoy
            solo sepas usar WhatsApp.
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4" data-id="element-77">
            <a href="#offer" className="w-full sm:w-auto px-8 py-4 bg-[#c9a84c] hover:bg-[#f0d060] text-[#0f1b33] font-bold text-lg rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-78">
              ¡QUIERO EMPEZAR MI CAMBIO HOY!
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-79" />
            </a>
          </div>

          <p className="mt-4 text-sm text-gray-400" data-id="element-80">
            * Oferta por tiempo limitado. Acceso inmediato.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 w-full max-w-lg" data-id="element-81">
          <div className="relative" data-id="element-82">
            <div className="absolute inset-0 bg-[#c9a84c] rounded-2xl blur-2xl opacity-20 transform rotate-3" data-id="element-83"></div>
            <img src="https://cdn.magicpatterns.com/uploads/orw8rtttsuREzR97mkzeDB/freelance_desde_cero_sin_ingles.png" alt="Freelance desde Cero (Sin Inglés) - Guía Digital" className="relative w-full h-auto rounded-xl shadow-2xl border border-[#3a5280] transform transition-transform hover:scale-[1.02] duration-500" data-id="element-84" />
          </div>
        </motion.div>
      </div>
    </section>;
}